import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Mount once inside <BrowserRouter>. Whenever the route changes (and
 * there's no hash fragment), snap the window back to the top.
 *
 * Routing libraries don't restore scroll position by default — without
 * this the next page opens halfway down the viewport, which feels
 * broken even when it isn't.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // honor explicit in-page anchor jumps
    // Use 'instant' so we don't animate during route transitions
    // (animation makes the new page feel slow).
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
